import { render, staticRenderFns } from "./good.vue?vue&type=template&id=341296c4&scoped=true"
import script from "./good.vue?vue&type=script&lang=js"
export * from "./good.vue?vue&type=script&lang=js"
import style0 from "./good.vue?vue&type=style&index=0&id=341296c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341296c4",
  null
  
)

export default component.exports